
const devAdmin = 'https://admin-staging.maya.tech'

module.exports = {
  url: devAdmin,
  alterUrl: 'https://admin.maya.tech',
  signUpUrl: 'http://docs-staging.maya.tech/terms_and_conditions_form/',
  apiUrl: 'https://api-staging.maya.tech/admin',
  proxySocketUrl: 'https://admin-staging.maya.tech/reactive-socket',
  apiAdminUrl: '/api',
  sso: {
    clientId: 'n5jWocaFhmtw1EomCXYL5a6j4FudwwwiPr4ymmPm',
  },
  assets: {
    receiptLink: 'https://dev.atm.cm/r/',
    paymentAssetsLink: devAdmin + '/assets/',
    cameraTestLink: devAdmin + '/assets/',
    fsLink: devAdmin + '/fs/',
    screenLink: devAdmin + '/assets/screenshots/',
  },
  webDocs: {
    link: 'https://dev.atm.cm/webdocs/',
  },
  alltrustLocationUrl: 'https://smartcheck-demo.herokuapp.com/admin/settings/locations/{id}/edit/'
}



// WEBPACK FOOTER //
// ./src/config/client.dev.js